import { FC } from 'react';
import { setAnotherTakeoutAddress, setTakeoutAddress, useAppDispatch } from '@/app/store';
import { Selector, SelectorVariantType } from '@/shared/components';
import { useTranslation } from 'react-i18next';

interface TakeoutSelectorProps {
  value?: string;
  className?: string;
  isCatalog?: boolean;
  onChange: VoidFunction;
  variantClassName?: string;
  selectorClassName?: string;
  onOpenChange?: VoidFunction;
  variants: SelectorVariantType[];
  selectContentClassName?: string;
  isOrderAnotherPerson?: boolean;
}

export const TakeoutSelector: FC<TakeoutSelectorProps> = ({
  value,
  variants,
  onChange,
  className,
  onOpenChange,
  variantClassName,
  selectorClassName,
  isCatalog = false,
  selectContentClassName,
  isOrderAnotherPerson = false,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('address');

  return (
    <Selector
      defaultOpen
      variants={variants}
      value={value ?? ''}
      onOpenChange={onOpenChange}
      placeholder={t('placeholders.pickupAddress')}
      onChange={(addressId) => {
        onChange();
        if (isOrderAnotherPerson) dispatch(setAnotherTakeoutAddress(addressId));
        else dispatch(setTakeoutAddress(addressId));
      }}
      className={className}
      disabledIcon={isCatalog}
      variantClassName={variantClassName}
      selectorClassName={selectorClassName}
      selectContentClassName={selectContentClassName}
    />
  );
};
